document.addEventListener('DOMContentLoaded', function () {
  const container = document.querySelector('.quiz-section-container');
  if (!container) return;

var swiper_quiz = new Swiper(".step-counter", {
  slidesPerView: 9,
  spaceBetween: 0,
  allowTouchMove: false,
  simulateTouch: false,
  noSwiping: true,
  preventInteractionOnTransition: true,
  breakpoints: {
    989: { slidesPerView: 7 },
    768: { slidesPerView: 5 },
    576: { slidesPerView: 3 },
    320: { slidesPerView: 2 },
  },
  on: {
    init: function () {
      const parentContainer = document.querySelector('.quiz-section-container');
      if (parentContainer) {
        parentContainer.classList.remove('hidden');
      }
    },
  },
});




  let highlightFilledSteps = []; 

  container.addEventListener('click', function (e) {
    const steps = document.querySelectorAll('.quiz-section-container .step-container .step');

    const nextBtn = e.target.closest('.tangent_survey_next_button_custom');
    if (nextBtn) {
      const activeSteps = Array.from(steps).filter(step => step.classList.contains('active'));
      const currentStep = activeSteps[activeSteps.length - 1];
      const currentIndex = Array.from(steps).indexOf(currentStep);

      if (currentStep.classList.contains('fill') && currentIndex + 1 < steps.length) {
        steps[currentIndex + 1].classList.add('active');
          swiper_quiz.slideTo(currentIndex + 1);
      }

      return;
    }

    // ✅ OPTION CLICK
    const option = e.target.closest('.tangent_options_custom');
    if (option) {
      const selectedTextEl = option.querySelector('.tngnt-option-text');
      const selectedText = selectedTextEl ? selectedTextEl.textContent.trim() : '';
      if (!selectedText) return;

      const activeSteps = Array.from(steps).filter(step => step.classList.contains('active'));
      const activeStep = activeSteps[activeSteps.length - 1];
      const currentIndex = Array.from(steps).indexOf(activeStep);
      if (!activeStep) return;

      if (currentIndex === 0 || currentIndex === 1) {
        const oldVal = activeStep.querySelector('.selected-value');
        if (oldVal) oldVal.remove();

        const valueDiv = document.createElement('div');
        valueDiv.className = 'selected-value';
        valueDiv.textContent = selectedText;
        activeStep.appendChild(valueDiv);
        activeStep.classList.add('fill');

        if (currentIndex + 1 < steps.length) {
          steps[currentIndex + 1].classList.add('active');
           swiper_quiz.slideTo(currentIndex + 1);
        }
      }

      if (
        (currentIndex === 2 || currentIndex === 3) &&
        option.classList.contains('tangent_option_highlight_custom') &&
        !highlightFilledSteps.includes(currentIndex)
      ) {
        activeStep.classList.add('fill');
        highlightFilledSteps.push(currentIndex);
      }

        if (
          (currentIndex === 4)
        ) {
        if (currentIndex + 1 < steps.length) {
          steps[currentIndex + 1].classList.add('active');
          steps[currentIndex + 1].classList.add('fill');
          swiper_quiz.slideTo(currentIndex + 1);
        }
        activeStep.classList.add('fill');
      }

      if (currentIndex === 5 ) {
        activeStep.classList.add('fill');
      }

      return;
    }

    // ✅ BACK BUTTON — smart remove logic with index check
    const backBtn = e.target.closest('.tangent_backbtn_custom');
    if (backBtn) {
      const steps = document.querySelectorAll('.quiz-section-container .step-container .step');

      const activeSteps = Array.from(steps).filter(step => step.classList.contains('active'));
      if (activeSteps.length > 1) {
        const currentStep = activeSteps[activeSteps.length - 1];
        const currentIndex = Array.from(steps).indexOf(currentStep);

        if (currentIndex === 0 || currentIndex === 1) {
          const selectedVal = currentStep.querySelector('.selected-value');
          if (selectedVal) selectedVal.remove();

          currentStep.classList.remove('fill');
          currentStep.classList.remove('active');
           swiper_quiz.slideTo(currentIndex - 1);

        } else if (currentIndex === 2 || currentIndex === 3 || currentIndex === 4 || currentIndex === 5) {
          currentStep.classList.remove('fill');
          currentStep.classList.remove('active');
          swiper_quiz.slideTo(currentIndex - 1);
        } else {
          if (currentStep.classList.contains('fill')) {
            currentStep.classList.remove('fill');
          } else {
            currentStep.classList.remove('active');
            swiper_quiz.slideTo(currentIndex - 1);
          }
        }

        const indexInFilled = highlightFilledSteps.indexOf(currentIndex);
        if (indexInFilled > -1) {
          highlightFilledSteps.splice(indexInFilled, 1);
        }
      }

      return;
    }

    // ✅ SKIP BUTTON — set static selected value + activate next step
    const skipBtn = e.target.closest('.tangent_survey_skip_button_custom');
    if (skipBtn) {
      const activeSteps = Array.from(steps).filter(step => step.classList.contains('active'));
      const activeStep = activeSteps[activeSteps.length - 1];
      if (!activeStep) return;

      const currentIndex = Array.from(steps).indexOf(activeStep);

      let staticValue = '';

      if (currentIndex === 1) {
        staticValue = 'Type';
      } 

      if (staticValue) {
        const oldVal = activeStep.querySelector('.selected-value');
        if (oldVal) oldVal.remove();

        const valueDiv = document.createElement('div');
        valueDiv.className = 'selected-value';
        valueDiv.textContent = staticValue;
        activeStep.appendChild(valueDiv);
      }
        activeStep.classList.add('fill');

      if (currentIndex === 4 && steps[currentIndex + 1]) {
        const nextStep = steps[currentIndex + 1];
        nextStep.classList.add('active');
        nextStep.classList.add('fill');
      } else if (currentIndex + 1 < steps.length) {
        steps[currentIndex + 1].classList.add('active');
      }
      return;
    }
  });
});
